/** The post processors Vectric and Carveco ship for supported controllers.
 * `.nc` is written by both Masso and Redline posts, so it names neither. */
export interface VendorPost {
  name: string;
  ext: string;
  units: 'INCHES' | 'MM';
  controller: string;
}

// Onefinity's stock controller is Buildbotics-based; CanCam's post targets Masso.
export const VECTRIC_POSTS: readonly VendorPost[] = [
  {
    name: 'Onefinity (Inch) (*.ngc)',
    ext: 'ngc',
    units: 'INCHES',
    controller: 'Buildbotics',
  },
  {
    name: 'Onefinity (MM) (*.ngc)',
    ext: 'ngc',
    units: 'MM',
    controller: 'Buildbotics',
  },
  {
    name: 'Onefinity Laser (inch) (*.gcode)',
    ext: 'gcode',
    units: 'INCHES',
    controller: 'Buildbotics',
  },
  {
    name: 'Onefinity Laser (MM) (*.gcode)',
    ext: 'gcode',
    units: 'MM',
    controller: 'Buildbotics',
  },
  {
    name: 'CanCam Masso ATC Arcs (inch) (*.nc)',
    ext: 'nc',
    units: 'INCHES',
    controller: 'Masso',
  },
  {
    name: 'CanCam Masso ATC Arcs (mm) (*.nc)',
    ext: 'nc',
    units: 'MM',
    controller: 'Masso',
  },
];

// "BB" is Buildbotics; "Realtime RTSX" is the Redline controller.
export const CARVECO_POSTS: readonly VendorPost[] = [
  {
    name: 'Onefinity - BB (inch) (*.ngc)',
    ext: 'ngc',
    units: 'INCHES',
    controller: 'Buildbotics',
  },
  {
    name: 'Onefinity - BB (mm) (*.ngc)',
    ext: 'ngc',
    units: 'MM',
    controller: 'Buildbotics',
  },
  {
    name: 'Onefinity BB Rotary (mm) (*.ngc)',
    ext: 'ngc',
    units: 'MM',
    controller: 'Buildbotics',
  },
  {
    name: 'Onefinity Masso (inch) (*.nc)',
    ext: 'nc',
    units: 'INCHES',
    controller: 'Masso',
  },
  {
    name: 'Onefinity Masso (mm) (*.nc)',
    ext: 'nc',
    units: 'MM',
    controller: 'Masso',
  },
  {
    name: 'Onefinity Masso ATC (inch) (*.nc)',
    ext: 'nc',
    units: 'INCHES',
    controller: 'Masso',
  },
  {
    name: 'Onefinity Masso ATC (mm) (*.nc)',
    ext: 'nc',
    units: 'MM',
    controller: 'Masso',
  },
  {
    name: 'Onefinity Masso Rotary X2A (inch) (*.nc)',
    ext: 'nc',
    units: 'INCHES',
    controller: 'Masso',
  },
  {
    name: 'Onefinity Masso Rotary X2A (mm) (*.nc)',
    ext: 'nc',
    units: 'MM',
    controller: 'Masso',
  },
  {
    name: 'Onefinity Masso Rotary Y2A (inch) (*.nc)',
    ext: 'nc',
    units: 'INCHES',
    controller: 'Masso',
  },
  {
    name: 'Onefinity Masso Rotary Y2A (mm) (*.nc)',
    ext: 'nc',
    units: 'MM',
    controller: 'Masso',
  },
  {
    name: 'Onefinity Masso Rotary ATC X2A (inch) (*.nc)',
    ext: 'nc',
    units: 'INCHES',
    controller: 'Masso',
  },
  {
    name: 'Onefinity Masso Rotary ATC X2A (mm) (*.nc)',
    ext: 'nc',
    units: 'MM',
    controller: 'Masso',
  },
  {
    name: 'Onefinity Masso Rotary ATC Y2A (inch) (*.nc)',
    ext: 'nc',
    units: 'INCHES',
    controller: 'Masso',
  },
  {
    name: 'Onefinity Masso Rotary ATC Y2A (mm) (*.nc)',
    ext: 'nc',
    units: 'MM',
    controller: 'Masso',
  },
  {
    name: 'Onefinity Realtime RTSX (inch)(*.nc)',
    ext: 'nc',
    units: 'INCHES',
    controller: 'Redline',
  },
  {
    name: 'Onefinity Realtime RTSX (mm)(*.nc)',
    ext: 'nc',
    units: 'MM',
    controller: 'Redline',
  },
  {
    name: 'Onefinity Realtime RTSX Rotary X2A (inch)(*.nc)',
    ext: 'nc',
    units: 'INCHES',
    controller: 'Redline',
  },
  {
    name: 'Onefinity Realtime RTSX Rotary X2A (mm)(*.nc)',
    ext: 'nc',
    units: 'MM',
    controller: 'Redline',
  },
  {
    name: 'Onefinity Realtime RTSX Rotary Y2A (inch)(*.nc)',
    ext: 'nc',
    units: 'INCHES',
    controller: 'Redline',
  },
  {
    name: 'Onefinity Realtime RTSX Rotary Y2A (mm)(*.nc)',
    ext: 'nc',
    units: 'MM',
    controller: 'Redline',
  },
];

export const VENDOR_POSTS: readonly VendorPost[] = [
  ...VECTRIC_POSTS,
  ...CARVECO_POSTS,
];
